import React from 'react';
import './SocialButton.css';

const SocialButton = ({ className, site, url }) => (
  <li className={className}>
    <a title={site} href={url} target="_blank" className={`pdp-social-icon pdp-social-${site}`}>{site} Share</a>
  </li>
);

export default SocialButton;



// WEBPACK FOOTER //
// ./src/components/SocialButton/index.js